import { Button, Col, Divider, Form, Image, Input, Row, Select } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";

// import { addPoster, editPoster, getBlogbyId, uploadImage } from "./PosterApi";
import { addPoster, editPoster, uploadImage } from "./PosterApi";
import { ImSpinner10 } from "react-icons/im";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { JsonEditor } from "json-edit-react";

function AddPoster () {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [contentData, setContentData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  // const [dashboardNewsImageURL, setDashboardNewsImageURL] = useState(from === "add" ? "" : contentData?.homePage);
  const [dashboardNewsImageURL, setDashboardNewsImageURL] = useState(from === "add" ? "" : fill?.destop_size);
  const [dashboardNewsImageUploading, setDashboardNewsImageUploading] = useState(false);
  const [newsPageImageURL, setNewsPageImageURL] = useState(from === "add" ? "" : fill?.mobile_size);
  // const [newsPageImageURL, setNewsPageImageURL] = useState(from === "add" ? "" : contentData?.image);
  const [newsPageImageUploading, setNewsPageImageUploading] = useState(false);

  // const handleFileUpload = useCallback(
  const handleDashboardNewsImageUpload = useCallback(
    async (e) => {
      try {
        setDashboardNewsImageUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        // setImageURL(url);
        setDashboardNewsImageURL(url);
        setContentData({ ...contentData, destop_size: url });
        setDashboardNewsImageUploading(false);
      } catch (error) {
        setDashboardNewsImageUploading(false);
        console.log({ error });
      }
    },
    [contentData]
  );

  const handleNewsPageImageUpload = useCallback(
    async (e) => {
      try {
        setNewsPageImageUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setNewsPageImageURL(url);
        setContentData({ ...contentData, mobile_size: url });
        setNewsPageImageUploading(false);
      } catch (error) {
        setNewsPageImageUploading(false);
        console.log({ error });
      }
    },
    [contentData]
  );
  
  // function fetchBlogDataByID () {
  //   getBlogbyId(`${fill?.id}`)
  //     .then((response) => {
  //       if (response?.success) {
  //         setContentData(response?.data?.blog);
  //         form.setFieldsValue(response?.data?.blog);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // }
  
  // useEffect(() => {
  //   from === "edit" && fetchBlogDataByID();
  // }, [form]);

  const AddPosterData = (values) => {
    const payload = {
      isActive: values.isActive,
      redirect_link: values.redirect_link,
      destop_size: dashboardNewsImageURL,
      mobile_size: newsPageImageURL
    };


    setIsLoading(true);

    addPoster(payload)
      .then((response) => {
        // if (response.status) {
        if (response?.status) {
          navigate("/get/poster_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const updatePosterData = (values) => {

    const payload = {
      isActive: values.isActive,
      redirect_link: values.redirect_link,
      destop_size: dashboardNewsImageURL,
      mobile_size: newsPageImageURL
    };
    
    setIsLoading(true);

    editPoster(payload, `${fill?._id}`)
      .then((response) => {
        if (response?.status) {
          navigate("/get/poster_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (fill) {
      form.setFieldsValue({
        isActive: fill.isActive,
        redirect_link: fill.redirect_link,
        destop_size: dashboardNewsImageURL,
        mobile_size: newsPageImageURL
      });
    }
  }, [form, fill]);

const metaTagOptions = ["description", "title", "keywords", "robots", "author"];

  return (
    <div>
      <Divider orientation="left" style={{ border: "#cecece" }} className="text-base tracking-normal font-dmsans font-normal  text-gray-900">
        {from === "edit" ? "Update" : "Add"} Poster
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) => (from === "add" ? AddPosterData(values) : updatePosterData(values))}
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Active Status</p>} name="isActive" rules={[{ required: true, message: "Please select an option" }]}>
              <Select placeholder="True" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Redirect Link</p>}
              name="redirect_link"
              rules={[
                { required: true, message: "Please enter Redirect Link" },
                { message: "Redirect Link is required" },
              ]}
            >
              <Input placeholder="Redirect Link" />
            </Form.Item>
          </Col>
        </Row>


        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
                // name="image"
                // name="dashboardNewsImage"
                name="destop_size"
                // label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">News Image</p>}
                label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Desktop Poster Image (Aspect Ratio must be 16/9)</p>}
                rules={[
                { required: true, message: "Desktop Poster Image is required" },
              ]}
                >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {/* {uploading ? ( */}
                {dashboardNewsImageUploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                // ) : imageURL ? (
                //   <Image src={imageURL} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                // ) : contentData?.image ? (
                //   <Image src={contentData?.image} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                ) : dashboardNewsImageURL ? (
                  <Image src={dashboardNewsImageURL} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                {/* <input type="file" name="photo" id="upload-photo" onChange={handleFileUpload} /> */}
                <input type="file" name="photo" id="upload-dashboard-news-image" onChange={handleDashboardNewsImageUpload} />
                {/* <label for="upload-photo" className="cursor-pointer"> */}
                <label for="upload-dashboard-news-image" className="cursor-pointer">
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
                {/* <button >Replace</button> */}
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
                // name="newsPageImage"
                name="mobile_size"
                label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Mobile Poster Image (Aspect Ratio must be 1/1)</p>}
                rules={[
                { required: true, message: "Mobile Poster Image is required" },
              ]}
                >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {newsPageImageUploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : newsPageImageURL ? (
                  <Image src={newsPageImageURL} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                <input type="file" name="photo" id="upload-news-page-image" onChange={handleNewsPageImageUpload} />
                <label for="upload-news-page-image" className="cursor-pointer">
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                navigate("/get/poster_details");
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            {/* <Button className="NoButtonHover create-button" size="small" htmlType="submit" loading={isLoading} disabled={uploading}> */}
            <Button className="NoButtonHover create-button" size="small" htmlType="submit" loading={isLoading} disabled={(dashboardNewsImageUploading || newsPageImageUploading)}>
              {from === "edit" ? "Update" : "Add"} Poster
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default AddPoster;
